import validate from "/Users/nestoras/Documents/GitHub/colorize-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/nestoras/Documents/GitHub/colorize-frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/middleware/auth.ts"),
  onboarding: () => import("/Users/nestoras/Documents/GitHub/colorize-frontend/middleware/onboarding.ts")
}